import { render, staticRenderFns } from "./BusinessGroup.vue?vue&type=template&id=095d7fcf&scoped=true"
import script from "./BusinessGroup.vue?vue&type=script&lang=js"
export * from "./BusinessGroup.vue?vue&type=script&lang=js"
import style0 from "./BusinessGroup.vue?vue&type=style&index=0&id=095d7fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095d7fcf",
  null
  
)

export default component.exports